import Icon from '../components/Icon.vue'

Icon.register({
  ban: {
    width: 512,
    height: 512,
    paths: [
      {
        d: 'M256 8c137 0 248 111 248 248s-111 248-248 248-248-111-248-248 111-248 248-248zM386.1 125.9c-65.4-65.4-165.4-70-235.6-20.7l256.3 256.3c49.3-70.2 44.8-170.2-20.7-235.6zM125.9 386.1c65.4 65.4 165.4 70 235.6 20.7l-256.3-256.3c-49.3 70.2-44.8 170.2 20.7 235.6z'
      }
    ]
  }
})



//////////////////
// WEBPACK FOOTER
// ./~/vue-awesome/icons/ban.js
// module id = 642
// module chunks = 0